import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Custom.
import Layout from "containers/Layout/Layout";
import { WrapperProps } from "../global";

const Content: React.FC<WrapperProps> = (props) => {
  const { children, title, hideTitleOnPrint } = props;
  return (
    <Layout>
      <Box
        className="vo-global__top-bottom-space"
        sx={(theme) => ({
          mt: 1,
          width: 1000,
        })}
      >
        {title && (
          <Typography
            variant="h4"
            component="h1"
            sx={{
              mb: 4,
              ...(hideTitleOnPrint
                ? {
                    "@media print": {
                      display: "none",
                    },
                  }
                : {}),
            }}
            textAlign="center"
          >
            {title}
          </Typography>
        )}
        {children}
      </Box>
    </Layout>
  );
};

export default Content;
